// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CollateralState } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/State/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useCollateralState: () => UseQueryResult<
  TemplateContract<CollateralState>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { operator } = useParties();
  return useQuery({
    queryKey: ['queryCollateralState', ledgerApi, offset, operator],
    queryFn: async () => {
      return ledgerApi.queryCollateralState(offset!, operator);
    },
    refetchInterval: false,
  });
};

export default useCollateralState;
